// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6535":"cb4f97fc3b5064da","8768":"7aa84fc5e2e40276"}[chunkId] + ".js";
};